import React, { ReactNode } from "react";
import styled from "styled-components";
import { Device } from "../../device";

interface MegadropdownProps
{
    visible: boolean;
    children?: ReactNode;
    fullscreen?: boolean;
}

const MegadropdownWrap = styled.div<MegadropdownProps>`
    position: fixed;
    left: 0;
    top: 0px;
    right: 0;
    z-index: 99;
    background-color: var(--color-black, black);
    color: var(--color-gray-90, black);
    padding: 1.5rem 1rem;
    margin-bottom: 30px;
    max-height: calc(100vh);
    min-height: ${props => (props.fullscreen) ? "calc(100vh)" : "0px"};
    overflow-x: 0;
    overflow-y: auto;
    ${Device.desktop} {
        padding-top: 3rem;
        padding-bottom: 3rem;
    }
    &.megadropdown--show {
        transform: translate3d(0,0,0);
        //transition: transform .7s cubic-bezier(.19,1,.22,1) 0ms;
    }
    &.megadropdown--hide {
        transform: translate3d(0,calc(-100% - 60px),0);
        //transition: opacity 1s cubic-bezier(.86,0,.07,1) 0ms;
    }

    
`;

const MegadropdownPage = styled.div`
    margin: 0 auto;
    ${Device.tablet} {
        padding-left: 1rem;
        padding-right: 1rem;
    }
`;

const Megadropdown = (props: MegadropdownProps) => (
    <MegadropdownWrap
        {...props}
        className={props.visible ? "megadropdown--show scrollbar" : "megadropdown--hide scrollbar"}>
        <MegadropdownPage className="container">
            {props.children}
        </MegadropdownPage>
    </MegadropdownWrap>
);

export default Megadropdown;